import {Link} from 'gatsby';
import React from 'react';

import {createLangShortcut} from '../../../utils/createLangShortcut';
import {cutText} from '../../../utils/cutText';
import {getLanguageFromUrl} from '../../../utils/getLanguageFromUrl';
import {getReadMoreString} from '../../../utils/getReadMoreString';
import imageSize from '../../../utils/imageSize.js';

export default function FeatureSplitColor(slice) {
  const linkedHero = slice.correctSlice?.primary;
  const {primary} = slice;
  const internalLink = primary.feature_link.uid;
  const externalLink = primary.feature_link.raw.url;
  const linkLang = primary.feature_link.lang;
  const title = slice.primary?.feature_title || slice.primary.feature_title?.html || linkedHero?.hero_title?.text;
  const kicker = slice.primary?.feature_kicker?.text;
  const image = slice.primary.feature_image?.fluid?.src || linkedHero?.hero_image?.fluid.src;
  const alt = slice.primary.feature_image?.alt;
  const brodtext = slice.primary?.feature_body?.text;
  const imgUrl = imageSize(image, 800);
  const line = slice.primary?.line;
  const filter = slice.primary?.feature_filter_select;
  const language = getLanguageFromUrl();

  return (
    <section className={'feature-full'}>
      <div className="feature-split-color">
        <div className="feature-content">
          <div className="feature-content-inner">
            {kicker && (
              <h4
                className="text-kicker font-semibold"
                style={!image ? {color: 'black'} : null}
                dangerouslySetInnerHTML={{__html: kicker}}
              ></h4>
            )}
            {title ? <h3 className="font-sm font-medium" dangerouslySetInnerHTML={{__html: title}} /> : null}
            {brodtext ? <p>{cutText(slice.primary.feature_body.text, 250)}</p> : null}
            {line ? <div className="featunderline"></div> : null}
            {internalLink ? (
              <Link to={'/' + createLangShortcut(linkLang) + '/' + internalLink}>
                <button>{primary.feature_button_label || getReadMoreString(language)}</button>
              </Link>
            ) : externalLink ? (
              <a href={externalLink} target="_blank" rel="noreferrer">
                <button>{primary.feature_button_label || getReadMoreString(language)}</button>
              </a>
            ) : null}
          </div>
        </div>
        <div className={`feature-img ${filter === 'standard' ? 'myfilter' : ''}`}>
          {imgUrl ? <img src={image} alt={alt} /> : null}
        </div>
      </div>
    </section>
  );
}
